export default {
      id: "booking-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.df848786.svg#booking",
      toString: function () {
        return this.url;
      }
    }